import SimpleClass from '../classes/SimpleClass';

export default class Accordion extends SimpleClass {
  constructor(element) {
    super();

    this.debug = false;

    this.classes = {
      ACTIVE: 'active',
    };

    // state
    this.state = {
      init: false,
      destroyed: false,
      open: element.classList.contains(this.classes.ACTIVE),
    };

    // dom selectors
    this.dom = {
      accordion: element,
      header: element.querySelector('.accordion-header'),
      body: element.querySelector('.accordion-body'),
    };

    // event listeners
    this.initEventListeners();

    // init
    this.init();
  }

  init() {
    this.log('✨ Accordion init');
    this.setState('init', true);
  }

  initEventListeners() {
    this.dom.header.addEventListener('click', (event) => {
      event.preventDefault();
      this.handleClick();
    });
  }

  handleClick() {
    this.setState('open', !this.state.open);

    if (this.state.open) {
      this.dom.accordion.classList.add(this.classes.ACTIVE);
      return;
    }
    this.dom.accordion.classList.remove(this.classes.ACTIVE);
  }

  getSwiper() {
    return this.swiper;
  }
}
